<template>
  <v-form ref="roleForm">
    <v-text-field
      v-model="data.Nombre"
      :rules="rules.name"
      label="Nombre"
      outlined
      dense
      required
    ></v-text-field>
    <v-select
      v-model="data.Deptos"
      :items="departamentos"
      :menu-props="{ maxHeight: '400' }"
      item-text="Nombre"
      item-value="Id"
      label="Departamentos restaurante"
      multiple
      persistent-hint
    ></v-select>

    <v-row>
      <v-col cols="2">
        <v-switch v-model="data.Activo" label="Activo"></v-switch>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2">
        <v-switch v-model="data.ESup" label="Es supervisor"></v-switch>
      </v-col>
    </v-row>

    <div class="text-right">
      <v-btn large @click="$emit('toggle', false)">Cancelar</v-btn>
      <v-btn style="margin-left: 6px" color="success" large @click="checkForm"
        >Guardar</v-btn
      >
    </div>
  </v-form>
</template>

<style scoped></style>

<script>
import Mesero from "../../../clases/Restaurante/Mesero";
export default {
  name: "MeserosForm",
  components: {},
  props: ["edit", "dataEdit"],
  data() {
    return {
      departamentos: [],
      data: {
        Activo: true,
        Deptos: [],
        Nombre: null,
        ESup: false,
      },
      rules: {
        name: [(value) => !!value || "El nombre del mesero es obligatorio"],
      },
    };
  },
  methods: {
    checkForm() {
      if (this.$refs.roleForm.validate()) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.send(doAction);
      }
    },
    send(action) {
      const dataSave = this.data;
      const departments = {};
      let auxArrayDep = [];
      this.data.Deptos.forEach(
        (department) => (departments[department] = true)
      );
      auxArrayDep = this.data.Deptos;
      dataSave.Deptos = departments;

      if (action === "EDIT") {
        // id de edicion
        dataSave.Id = this.dataEdit.id;
      }

      this.$emit("successData", dataSave, action);
      //dataSave.Deptos = auxArrayDep;
    },
    async getDepartamentosAB() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Departamentos"
        );
      if (snapshot.exists()) {
        this.departamentos = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            this.departamentos.push(toAdd);
          }
        });
      }
    },
  },
  async mounted() {
    await this.getDepartamentosAB();
    if (this.edit) {
      if(this.dataEdit?.Deptos){
        Object.keys(this.dataEdit.Deptos).forEach((department) =>
          this.data.Deptos.push(department)
        );
      }
      
      this.data.Activo = this.dataEdit.Activo;
      this.data.Nombre = this.dataEdit.Nombre;
      this.data.ESup = this.dataEdit.ESup;
    }
  },
};
</script>
